import * as React from "react";

import { Company } from "../../../../domain/model/company";

import Progress from "../../../common/organism/progress";

import { useEffect } from "react";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import { TBreadcrumbItem } from "../../../type/common";
import ClientMypageMainCompanyForm from "./edit_company/client_mypage_main_company_form";

interface IProps {
  isLoading: boolean;
  company: Company | null;
  handleUpdateCompanySubmit: (values: any) => void;
}

const ClientMyPageCompanyEditComponent: React.FC<IProps> = (props) => {
  const { isLoading, company, handleUpdateCompanySubmit } = props;

  const initialValues = { company };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    routeConfig.clientMypageCompanyInfo,
    routeConfig.clientMypageCompanyEdit,
  ];

  useEffect(() => {
    window.addEventListener("beforeunload", onUnload);

    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };
  });

  const onUnload = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <Breadcrumbs breadcrumbItems={breadcrumbItems} />
          <ClientMypageMainCompanyForm
            // For Redux-Form
            initialValues={initialValues}
            onSubmit={handleUpdateCompanySubmit}
            enableReinitialize={true}
          />
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientMyPageCompanyEditComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/client_mypage_edit_company.tsx